import styled from 'styled-components';

export const Container = styled.div`
  > div {
    margin-bottom: 2rem;
  }

  p.MuiFormHelperText-root.Mui-error {
    margin-top: 0;
    margin-bottom: 0;
  }
`;
